import { render } from "./Employees.vue?vue&type=template&id=6a0f2554&scoped=true"
import script from "./Employees.vue?vue&type=script&lang=ts"
export * from "./Employees.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Employees.vue?vue&type=style&index=1&id=6a0f2554&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a0f2554"

export default script